import React from "react";
import { ImageUploader } from "ui/pages/TemplatePreview/widgets";
import sidebarStyles from "./../../../style.module.css";
import {
  DEFAULT_COVER_IMAGE,
  TEMPLATE_KEYS,
} from "ui/pages/TemplatePreview/constants";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

export const BackgroundImage = ({
  state,
  setField,
  slug_value,
  imageParams,
  disableAllEdits,
}) => {
  return slug_value === TEMPLATE_KEYS.UNLOCK ? (
    <div className={sidebarStyles.fieldContainer}>
      <div className={sidebarStyles.label}>Background image</div>
      <div className={sidebarStyles.field}>
        <ImageUploader
          hideRecommendedText
          uploadUrl={
            state?.social_info?.statistics_background_image ||
            DEFAULT_COVER_IMAGE[TEMPLATE_KEYS.UNLOCK]
          }
          setUploadUrl={(firebaseUrl) => {
            setField("social_info", {
              ...state?.social_info,
              statistics_background_image: firebaseUrl,
            });
          }}
          hoverText="Upload Image"
          fullWidth={imageParams.fullWidth}
          width={imageParams.width}
          height={imageParams.height}
          borderRadius="0%"
          query={"statistics images"}
          id="website_statistics_bg"
          disabled={disableAllEdits}
          uploadViaOptimization
          sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
        />
      </div>
      <div className={sidebarStyles.photoWidgetText}>
        Recommended format: {imageParams.fullWidth}&nbsp;&times;&nbsp;
        {Math.round(imageParams.fullWidth / imageParams.baseAspectRatio)} pixels
        (PNG or JPG)
      </div>
    </div>
  ) : null;
};
